var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuvHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29436",
    "data-name": "Group 29436",
    transform: "translate(-556 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(556 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_15_",
    "data-name": "svgexport-17 (15)",
    transform: "translate(570 431.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50536",
    "data-name": "Path 50536",
    d: "M394.235,280h-1.788a.447.447,0,0,0-.447.447v4.471a.447.447,0,0,0,.447.447h1.788a2.682,2.682,0,1,0,0-5.365Z",
    transform: "translate(-371.434 -272.4)",
    fill: "#445496"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_511",
    "data-name": "Ellipse 511",
    cx: 3.112,
    cy: 3.112,
    rx: 3.112,
    ry: 3.112,
    transform: "translate(17.893 7.001)",
    fill: "#2c3e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50537",
    "data-name": "Path 50537",
    d: "M101.412,280H99.624a.447.447,0,0,0-.447.447v4.471a.447.447,0,0,0,.447.447h1.788a2.682,2.682,0,1,0,0-5.365Zm-11.177,0H88.447a.447.447,0,0,0-.447.447v4.471a.447.447,0,0,0,.447.447h1.788a2.682,2.682,0,1,0,0-5.365Z",
    transform: "translate(-84.423 -272.4)",
    fill: "#445496"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50538",
    "data-name": "Path 50538",
    d: "M49.931,149.812v3.577a.894.894,0,0,1-.894.894H25.788A1.788,1.788,0,0,1,24,152.495v-4.81a1.342,1.342,0,0,1,.393-.948l1.951-1.951a2.683,2.683,0,0,1,1.9-.786H39.03a4.025,4.025,0,0,1,2.649,1l2.439,2.134h3.13a2.68,2.68,0,0,1,2.682,2.682Z",
    transform: "translate(-24 -144)",
    fill: "#5771e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50539",
    "data-name": "Path 50539",
    d: "M344.494,202.682v3.577a.894.894,0,0,1-.894.894h-5.812a.894.894,0,0,0,.894-.894v-3.577A2.682,2.682,0,0,0,336,200h5.812a2.68,2.68,0,0,1,2.682,2.682Z",
    transform: "translate(-318.564 -196.87)",
    fill: "#6e8beb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50540",
    "data-name": "Path 50540",
    d: "M49.931,258.234v.894a.894.894,0,0,1-.894.894H25.788A1.788,1.788,0,0,1,24,258.235h.447l.671-.839a3.721,3.721,0,0,1,5.811,0l.671.839h4.024l.671-.839a3.721,3.721,0,0,1,5.811,0l.671.839Z",
    transform: "translate(-24 -249.74)",
    fill: "#89a8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50541",
    "data-name": "Path 50541",
    d: "M89.436,147.13H72L74.235,144H84.348A4.025,4.025,0,0,1,87,145Z",
    transform: "translate(-69.318 -144)",
    fill: "#96cffa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50542",
    "data-name": "Path 50542",
    d: "M207.4,147.13h-5.365L199.6,145a4.025,4.025,0,0,0-2.65-1h5.365a4.025,4.025,0,0,1,2.649,1Z",
    transform: "translate(-187.285 -144)",
    fill: "#c4e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50543",
    "data-name": "Path 50543",
    d: "M176,296h.894v1.788H176Z",
    transform: "translate(-167.505 -287.506)",
    fill: "#6e8beb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50544",
    "data-name": "Path 50544",
    d: "M154.235,205.365h-.894v-1.156l-1.21-1.21a.447.447,0,0,1-.131-.316V200h.894v2.5l1.21,1.21a.447.447,0,0,1,.131.316Z",
    transform: "translate(-144.847 -196.87)",
    fill: "#4356e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50545",
    "data-name": "Path 50545",
    d: "M152,144h.894v3.13H152Z",
    transform: "translate(-144.847 -144)",
    fill: "#7ab8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50546",
    "data-name": "Path 50546",
    d: "M24,224h1.788l-.894,1.341H24Z",
    transform: "translate(-24 -219.529)",
    fill: "#f28868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50547",
    "data-name": "Path 50547",
    d: "M192,232h1.341v.894H192Z",
    transform: "translate(-182.611 -227.082)",
    fill: "#4356e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_512",
    "data-name": "Ellipse 512",
    cx: 2.334,
    cy: 2.334,
    rx: 2.334,
    ry: 2.334,
    transform: "translate(1.556 7.779)",
    fill: "#e4e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50548",
    "data-name": "Path 50548",
    d: "M50.682,285.365a2.682,2.682,0,1,1,2.682-2.682A2.682,2.682,0,0,1,50.682,285.365Zm0-4.471a1.788,1.788,0,1,0,1.788,1.788A1.788,1.788,0,0,0,50.682,280.894Z",
    transform: "translate(-46.659 -272.4)",
    fill: "#56679c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50549",
    "data-name": "Path 50549",
    d: "M374.706,296v.894a.894.894,0,0,1-.894.894H368a.894.894,0,0,0,.894-.894V296Z",
    transform: "translate(-348.776 -287.506)",
    fill: "#a2c1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50550",
    "data-name": "Path 50550",
    d: "M367.153,232.894v.894h-5.812A1.342,1.342,0,0,1,360,232.447V232h7A2.676,2.676,0,0,1,367.153,232.894Z",
    transform: "translate(-341.223 -227.082)",
    fill: "#89a8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50551",
    "data-name": "Path 50551",
    d: "M362.235,233.788h-.894A1.341,1.341,0,0,1,360,232.447V232h2.235Z",
    transform: "translate(-341.223 -227.082)",
    fill: "#a2c1fa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_513",
    "data-name": "Ellipse 513",
    cx: 0.778,
    cy: 0.778,
    rx: 0.778,
    ry: 0.778,
    transform: "translate(3.112 9.335)",
    fill: "#cad8ed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_514",
    "data-name": "Ellipse 514",
    cx: 2.334,
    cy: 2.334,
    rx: 2.334,
    ry: 2.334,
    transform: "translate(13.225 7.779)",
    fill: "#e4e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50552",
    "data-name": "Path 50552",
    d: "M250.682,285.365a2.682,2.682,0,1,1,2.682-2.682A2.682,2.682,0,0,1,250.682,285.365Zm0-4.471a1.788,1.788,0,1,0,1.788,1.788A1.788,1.788,0,0,0,250.682,280.894Z",
    transform: "translate(-235.482 -272.4)",
    fill: "#56679c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_515",
    "data-name": "Ellipse 515",
    cx: 0.389,
    cy: 0.778,
    rx: 0.389,
    ry: 0.778,
    transform: "translate(14.781 9.335)",
    fill: "#cad8ed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuvHighlighted);
export default __webpack_public_path__ + "static/media/SUVHighlighted.1c11b48b0e578e7526a3979d403a855d.svg";
export { ForwardRef as ReactComponent };